import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Projects } from '@app/core/plugin';
import { CoreStateService } from '@app/core/services';
import { map, Observable, Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-card-network-projects',
  templateUrl: './card-network-projects.component.html',
  styleUrls: ['./card-network-projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardNetworkProjectsComponent implements OnInit, OnDestroy {
  public posts$: Observable<Projects[]>;

  public isShowNormalPosts$: Observable<boolean>;

  private _destroy$ = new Subject<void>();

  constructor(
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  public ngOnInit() {
    this.isShowNormalPosts$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );
    this.posts$ = this.coreStateService.plugin$.pipe(map((plugin) => plugin.handler.home.networkProjects));
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
